<script>
import { filtersComputed, filtersMethods, deviceGroupComputed } from '@state/helpers'

export default {
  computed: {
    ...filtersComputed,
    ...deviceGroupComputed,

    filteredGroups: function() {
      return this.cachedGroups.filter((group) => {
        if (this.deviceFilters.searchGroup && this.deviceFilters.name != null) {
          return group.name.toLowerCase().includes(this.deviceFilters.name.toLowerCase())
        } else {
          return this.cachedGroups
        }
      })
    },

    filteredShifts: function() {
      return this.availableInsightsFilters.shifts.filter((shiftPatternName) => {
        if (this.shiftFilters != null) {
          return shiftPatternName.toLowerCase().includes(this.shiftFilters.toLowerCase())
        } else {
          return this.availableInsightsFilters.shifts
        }
      })
    },
  },

  methods: {
    ...filtersMethods,

    toggleShowRunningChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.showRunning = event.target.checked

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    toggleShowIdleChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.showIdle = event.target.checked

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    toggleSearchGroupChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.searchGroup = event.target.checked
      newDeviceFilters.name = null

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    deviceNameChanged: function(name) {
      let newDeviceFilters = { ...this.deviceFilters }

      newDeviceFilters.name = name.toUpperCase()
      this.setDeviceFilters({
        device: newDeviceFilters,
      })
    },

    selectedGroupChanged: function(groupName) {
      if (groupName === this.deviceFilters.name) {
        let newDeviceFilters = { ...this.deviceFilters }
        newDeviceFilters.searchGroup = false
        newDeviceFilters.name = null

        this.setDeviceFilters({ device: newDeviceFilters })
      } else {
        let newDeviceFilters = { ...this.deviceFilters }
        newDeviceFilters.searchGroup = true
        newDeviceFilters.name = groupName

        this.setDeviceFilters({ device: newDeviceFilters })
      }
    },

    selectedShiftChanged: function(shiftPatternName) {
      if (shiftPatternName === this.shiftFilters) {
        this.setShiftFilters({ shiftPatternName: null })
      } else {
        this.setShiftFilters({ shiftPatternName: shiftPatternName })
      }
    },
  },
}
</script>

<template>
  <b-tabs>
    <b-tab v-if="true" title="DATE" active> <BaseInfoSideFiltersDateInsights /></b-tab>
    <b-tab title="GROUP">
      <button
        v-for="group in filteredGroups"
        :key="group.id"
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase"
        @click="selectedGroupChanged(group.name)"
      >
        {{ group.name }}
      </button>
    </b-tab>

    <b-tab v-if="availableInsightsFilters.shifts.length > 0" title="SHIFT">
      <button
        v-for="shift in filteredShifts"
        :key="shift.id"
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase"
        @click="selectedShiftChanged(shift)"
      >
        {{ shift }}
      </button>
    </b-tab>
  </b-tabs>
</template>

<style>
.filter {
  padding: 1rem;
  border-bottom: 1px solid #23282c;
  margin-bottom: 0 !important;
}

.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}

.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
.aside-menu .nav-tabs .nav-link {
  font-size: 1.09375rem !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}
.insights-list:first-child {
  border-top: none;
}
</style>
